// extracted by mini-css-extract-plugin
module.exports = {"primary":"Button_primary__2NNkt","default":"Button_default__3oaRN","empty":"Button_empty__1Qmh_","secondary":"Button_secondary__2as4a","danger":"Button_danger__3aXxF"};